import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './kpi.constants';

import * as types from './kpi.types';
import * as services from './kpi.saga-services';

function* invokeSaveScoreboard(action: types.ISaveScoreboard) {
  yield call(services.saveScoreboard, action.payload);
}

function* invokeCreateScore(action: types.ICreateScore) {
  yield call(services.createScore, action.payload);
}

function* invokeUpdateScore(action: types.IUpdateScore) {
  yield call(services.updateScore, action.payload.scoreId, action.payload.data);
}

function* invokeUpdateScoresBulk(action: types.IUpdateScoresBulk) {
  yield call(services.updateScoresBulk, action.payload.scoreIds, action.payload.userId);
}

function* invokeDeleteScore(action: types.IDeleteScore) {
  yield call(services.deleteScore, action.payload);
}

function* invokeSaveScoreOrder(action: types.ISaveScoreOrder) {
  yield call(services.saveScoreOrder, action.payload.scoreIds);
}

function* invokeSaveScoreOrderSocket(action: types.ISaveScoreOrderSocket) {
  yield call(services.saveScoreOrderFromNotification, action.payload);
}

function* invokeFetchKpi(action: types.IFetchKpi) {
  yield call(services.fetchKpi, action.payload.meetingId, action.payload.queryParams);
}

function* invokeSaveScoreboardSocket(action: types.ISaveScoreboardSocket) {
  yield call(services.handleScoreboardFromNotification, action.payload);
}

function* invokeSaveScoreSocket(action: types.ISaveScoreSocket) {
  yield call(services.handleScoreFromNotification, action.payload);
}

function* invokeDeleteScoreSocket(action: types.IDeleteScoreSocket) {
  yield call(services.handleDeleteScoreFromNotification, action.payload);
}

export function* watchKpiPageSaga() {
  yield takeLatest(constants.SAVE_SCOREBOARD, invokeSaveScoreboard);
  yield takeLatest(constants.CREATE_SCORE, invokeCreateScore);
  yield takeLatest(constants.UPDATE_SCORE, invokeUpdateScore);
  yield takeLatest(constants.UPDATE_SCORES_BULK, invokeUpdateScoresBulk);
  yield takeLatest(constants.DELETE_SCORE, invokeDeleteScore);
  yield takeLatest(constants.SAVE_SCORE_ORDER, invokeSaveScoreOrder);
  yield takeLatest(constants.FETCH_KPI, invokeFetchKpi);

  yield takeLatest(constants.DELETE_SCORE_SOCKET, invokeDeleteScoreSocket);
  yield takeLatest(constants.SAVE_SCORE_SOCKET, invokeSaveScoreSocket);
  yield takeLatest(constants.SAVE_SCORE_ORDER_SOCKET, invokeSaveScoreOrderSocket);
  yield takeLatest(constants.SAVE_SCOREBOARD_SOCKET, invokeSaveScoreboardSocket);
}
